import React from "react";

export default function Meley() {
  return <div className="p-8">Meley Tracker (coming soon)</div>;
}
